<template>
	<PaymentResponse :status="message.linker_payment_status" :message="content" />
</template>

<script setup>
import { PaymentStatuses } from '@/components/whatsapp-managment/interfaces.js';
import { MessageTypes } from '@/components/whatsapp-managment/interfaces.js';
import { computed } from 'vue';
import PaymentResponse from './PaymentResponse';

const props = defineProps({
	status: String,
	message: String,
	data: {
		type: Object,
		default: null,
	},
});

const images = {
	failure: 'alert-circle.svg',
	success: 'check-circle.svg',
};

const content = computed(() => {
	if (props.message?.type === MessageTypes.Template) {
		return props.message?.extra_data?.template?.components?.[1]?.text;
	}

	return props.message?.content;
});

const loadFile = (fileName) => {
	return window.location.origin + '/assets/image/' + fileName;
};
</script>

<style scoped lang="scss">
@import './styles/paymentResponse.scss';
</style>
